
import React, { Component} from 'react';
import ManageVoicemailForm from './ManageVoicemailForm';
import { connect } from 'react-redux';

import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { products } from '../../services';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';

class ManageVoicemail extends Component {
  constructor(){
    super()
    this.state = {
      data: '',
    };
  }
  componentDidMount(){
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getProduct(ProductId)
      .then((res) => {
        this.setState({
          data: res.body.data.userProduct.Data,
        });
      });
  }
  render(){
    const { data } = this.state
    const { translate, rest } = this.props

    return(
      <div className="service-action" >
        <div className="card card-service-action">
          <div className="card-block">
            <h4 className="card-title">
              <div className="row">
                <div className="col-12 col-md-8"><span>{translate('manage-my-voicemail')}</span></div>
                <div className="col-12 col-md-4 text-md-right"><span>{PhoneNumberFormat(data.phoneNumber)}</span></div>
              </div>
            </h4>
            <ManageVoicemailForm rest={rest} />
          </div>
        </div>
      </div>
    )
  }

}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

ManageVoicemail = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ManageVoicemail);
export default ManageVoicemail;



// WEBPACK FOOTER //
// ./src/components/ManageVoicemail/ManageVoicemail.js